import { ISearchResultItem, ISearchResults } from '../models/service-now-model';
import { SearchResult, SearchResults } from '../models/search-viewmodel';
import { IconTypes } from '@/shared/models/icon-types';

/**
 * Mapper for the SearchOverlay Results
 */
export default class ServiceNowMapper {
    public mapSearchResults(item: ISearchResults): SearchResults {
        return new SearchResults(
            item.numberOfResults,
            item.results ? item.results.map((result: ISearchResultItem) => this.mapSearchResult(result)) : []
        );
    }

    private mapSearchResult(item: ISearchResultItem): SearchResult {
        return new SearchResult(
            item.title,
            item.url,
            IconTypes.Default,
            item.snippet,
            []
        );
    }
}
